/**
 * Validation helper for the photo_upload question type.
 *
 * Used by the SurveySession to decide whether the respondent can advance to
 * the next question. The respondent is allowed to proceed when:
 *   - At least one uploaded image has finished extraction successfully
 *     (`extraction_status === 'completed'`), OR
 *   - The respondent provided a non-empty typed answer via the
 *     ``text_fallback`` field (the fail-safe shown when image parsing fails).
 */

export interface PhotoUploadResponseLike {
  images?: Array<{ extraction_status?: string }>;
  text_fallback?: string;
  [key: string]: unknown;
}

export const isPhotoUploadResponseValid = (response: PhotoUploadResponseLike | null | undefined): boolean => {
  if (!response) return false;

  const hasCompletedImage =
    Array.isArray(response.images) &&
    response.images.some((img) => img?.extraction_status === 'completed');

  const hasTextFallback =
    typeof response.text_fallback === 'string' &&
    response.text_fallback.trim().length > 0;

  return hasCompletedImage || hasTextFallback;
};
